export default __webpack_public_path__ + "static/media/sketch-worldcup-tn.5e6fc48b.png";